import { useEffect, useState } from 'react'
import ListaEnvioEmailHttp from '../../../../services/api/https/registration/lista-envio-email.http'
import { getCentraisOperacoes } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

export const ListaEnvioEmailActions = {
  LOADING_NONE: 'LOADING_NONE',
  LOADING_LISTAS_ENVIO: 'LOADING_LISTAS_ENVIO',
  LOADING_SALVANDO_LISTA: 'LOADING_SALVANDO_LISTA',
  EXCLUINDO_LISTA: 'EXCLUINDO_LISTA',
}

export default function useListaEnvioEmailState() {
  const [centraisOperacionais] = useState(getCentraisOperacoes())
  const [centralSelecionada, setCentralSelecionada] = useState('')
  const [listas, setListas] = useState([])
  const [listaSelecionada, setListaSelecionada] = useState(null)
  const [navigateToEmails, setNavigateToEmails] = useState(false)
  const [loading, setLoading] = useState(ListaEnvioEmailActions.LOADING_NONE)
  const [erro, setErro] = useState(null)

  useEffect(() => {
    Array.isArray(centraisOperacionais) &&
      centraisOperacionais.length === 1 &&
      setCentralSelecionada(centraisOperacionais[0])
  }, [])

  useEffect(() => {
    centralSelecionada !== '' && fetchListas()
  }, [centralSelecionada])

  // Events
  function onCentralChange(central) {
    setCentralSelecionada(central)
  }

  function onModalResponse(action, payload) {
    if (action === 'CLOSE') {
      setListaSelecionada(null)
    } else {
      salvarLista(payload)
    }
  }
  function onMenuItemClicked(menuItem, lista) {
    if (menuItem === 'Emails') {
      setListaSelecionada({ ...lista, ativo: lista.ativo ? true : false })
      setNavigateToEmails(true)
    } else if (menuItem === 'Excluir') {
      excluirLista(lista)
    } else if (menuItem === 'Editar') {
      setListaSelecionada({ ...lista, ativo: lista.ativo ? true : false })
    }
  }
  function onBtnNovoClick() {
    if (centralSelecionada === '') setErro('Selecione a Central Desejada')
    else setListaSelecionada({ id: null, nome: '', ativo: true })
  }
  function resetError() {
    setErro(null)
  }

  // Helpers
  async function excluirLista(lista) {
    try {
      setLoading(ListaEnvioEmailActions.EXCLUINDO_LISTA)
      await ListaEnvioEmailHttp.excluirLista(lista.id)
      setListas(prevLista => prevLista.filter(l => l.id !== lista.id))
    } catch (error) {
      setErro(errorHandler(error))
    } finally {
      setLoading(ListaEnvioEmailActions.LOADING_NONE)
    }
  }

  async function salvarLista(lista) {
    try {
      setListaSelecionada(null)
      setLoading(ListaEnvioEmailActions.LOADING_SALVANDO_LISTA)
      if (centralSelecionada && centralSelecionada !== '') {
        const { id, nome, ativo } = lista
        if (nome.trim() === '') throw new Error('Insira um nome valido')
        else {
          const listaSalva = await ListaEnvioEmailHttp.salvarLista(
            id,
            nome,
            ativo,
            centralSelecionada.id,
          )
          atualizarLista(listaSalva)
        }
        setLoading(ListaEnvioEmailActions.LOADING_NONE)
      }
    } catch (error) {
      setLoading(ListaEnvioEmailActions.LOADING_NONE)
      setErro(errorHandler(error))
    }
  }
  function atualizarLista(lista) {
    setListas(prevLista => {
      const index = prevLista.findIndex(l => l.id === lista.id)
      if (index !== -1) {
        prevLista[index] = lista
      } else {
        prevLista.push(lista)
      }
      return [...prevLista]
    })
  }
  async function fetchListas() {
    try {
      setLoading(ListaEnvioEmailActions.LOADING_LISTAS_ENVIO)
      const { id } = centralSelecionada
      const _listas = await ListaEnvioEmailHttp.getListas(id)
      setListas(_listas)
      setLoading(ListaEnvioEmailActions.LOADING_NONE)
    } catch (error) {
      setLoading(ListaEnvioEmailActions.LOADING_NONE)
      setErro(errorHandler(error))
    }
  }

  return {
    centraisOperacionais,
    centralSelecionada,
    listas,
    listaSelecionada,
    navigateToEmails,
    loading,
    erro,
    onCentralChange,
    onModalResponse,
    onMenuItemClicked,
    onBtnNovoClick,
    resetError,
  }
}
